import humps from 'humps'

import { porticoApi } from 'store/porticoApi'

import { TRole } from 'types/roles'
import {
  TAccount,
  TAccountWithRoles,
  TCreateAccount,
  TCreateUserResponse,
  TEditAccount,
  TRoleAssignment,
} from 'types/accounts'
import { tranformAccountsToAccountsWithRoles } from 'utils/accounts/tranformAccountsToAccountsWithRoles'

type TRoleAssignmentResponse = {
  roleAssignments: TRoleAssignment[]
}
type TRoleResponse = {
  userRoles: TRole[]
}

const accounts = porticoApi.injectEndpoints({
  endpoints: (builder) => ({
    getAccounts: builder.query<TAccountWithRoles[], void>({
      async queryFn(_arg, _queryApi, _extraOptions, fetchWithBQ) {
        const accounts = await fetchWithBQ('operator/users')
        const roleAssignments = await fetchWithBQ('operator/role_assignments')
        const userRoles = await fetchWithBQ('operator/user_roles')

        const allAccounts = accounts?.data as TAccount[]
        const allRoleAssignmentsData = roleAssignments?.data as TRoleAssignmentResponse
        const allUserRolesData = userRoles?.data as TRoleResponse

        const allRoleAssignments: TRoleAssignment[] = allRoleAssignmentsData?.roleAssignments
        const allUserRoles: TRole[] = allUserRolesData?.userRoles

        const allAccountsWithRoleNameAndRoleAssignments = tranformAccountsToAccountsWithRoles(
          allAccounts,
          allRoleAssignments,
          allUserRoles
        )

        return { data: allAccountsWithRoleNameAndRoleAssignments ?? [] }
      },

      providesTags: (result) =>
        result ? [...result.map(({ id }) => ({ type: 'Accounts' as const, id }))] : ['Accounts'],
    }),
    createAccount: builder.mutation<TCreateUserResponse, TCreateAccount>({
      query: (data) => ({
        url: '/operator/users',
        method: 'POST',
        body: humps.decamelizeKeys(data),
      }),
      invalidatesTags: ['Accounts'],
    }),
    updateAccount: builder.mutation<TCreateUserResponse, TEditAccount>({
      query: ({ id, firstName, lastName, email, phoneNumber, accountStatus }) => ({
        url: `/operator/users/${id}`,
        method: 'PATCH',
        body: humps.decamelizeKeys({ firstName, lastName, email, phoneNumber, accountStatus }),
      }),
      invalidatesTags: ['Accounts'],
    }),
  }),
})

export const { useGetAccountsQuery, useCreateAccountMutation, useUpdateAccountMutation } = accounts
